import { z } from "zod";

export const PayStandAddressSchema = z.object({
  street1: z.string(),
  street2: z.string().optional(),
  city: z.string(),
  state: z.string(),
  postalCode: z.string(),
  country: z.string(),
});

export type PayStandAddressType = z.infer<typeof PayStandAddressSchema>;
